module.exports = __webpack_public_path__ + "img/image134.91f017ba.jpg";